import axios from 'axios';
import { encryptData } from 'services/encription_service';

// export const baseURL = "https://api.dgddl.test";
export const baseURL = "https://apiv2.dgddl.in";
// export const baseURL = process.env.REACT_APP_BASEURL;

const axiosApi = axios.create({ baseURL });

let activeRequests = 0;
let progressTimer = null;

const getProgressBar = () => {
  if (typeof document === 'undefined' || !document.body) return null;
  let el = document.getElementById('global-top-progress');
  if (!el) {
    el = document.createElement('div');
    el.id = 'global-top-progress';
    document.body.appendChild(el);
  }
  return el;
};

export const startTopLoader = () => {
  activeRequests++;
  const bar = getProgressBar();
  if (bar) {
    bar.className = 'loading';
    bar.style.width = `${Math.min(30 + activeRequests * 15, 85)}%`;
  }
};

export const stopTopLoader = () => {
  activeRequests = Math.max(0, activeRequests - 1);
  const bar = getProgressBar();
  if (bar && activeRequests === 0) {
    bar.style.width = '100%';
    clearTimeout(progressTimer);
    progressTimer = setTimeout(() => {
      bar.className = 'done';
      setTimeout(() => {
        bar.style.width = '0%';
        bar.className = '';
      }, 300);
    }, 200);
  }
};

axiosApi.interceptors.request.use(
  config => {
    startTopLoader();
    return config;
  },
  error => {
    stopTopLoader();
    return Promise.reject(error);
  }
);

axiosApi.interceptors.response.use(
  response => {
    stopTopLoader();
    return response;
  },
  error => {
    stopTopLoader();
    return Promise.reject(error);
  }
);

// Handle global response errors
const check = (e) => {
  if (e?.response?.status === 401) {
    localStorage.clear();
    window.location.href = '/';
    return { status: 401, err: 'unauthorized' };
  }

  if (e?.response?.status === 500) {
    return { status: 500, err: 'server error' };
  }

  if (e?.response?.data) {
    return e.response.data;
  }

  return { status: e?.response?.status || 500, err: e?.message || 'error' };
};

// ✅ Safely add Authorization header
const addAuthHeader = () => {
  const token = localStorage.getItem('token');
  if (token && token !== 'null' && token !== 'undefined') {
    axiosApi.defaults.headers.common["Authorization"] = token;
  } else {
    delete axiosApi.defaults.headers.common["Authorization"];
  }
};

export async function get(url, config = {}) {
  addAuthHeader();
  try {
    const response = await axiosApi.get(url, { ...config });
    return response.data;
  } catch (e) {
    return check(e);
  }
}

export async function post(url, data, config = {}) {
  addAuthHeader();
  const isProd = typeof process !== 'undefined' && process.env.REACT_APP_NODE_ENV === 'prod';
  const payload = isProd
    ? { ...data }
    : encryptData({ ...data }); // Remove the array wrapper if it was causing issues, or keep if required by backend

  try {
    const response = await axiosApi.post(url, payload, { ...config });
    return response.data;
  } catch (e) {
    return check(e);
  }
}

export async function uploadfile(url, data) {
  const token = localStorage.getItem('token');
  const myHeaders = new Headers();
  if (token && token !== 'null' && token !== 'undefined') {
    myHeaders.append("Authorization", token);
  }

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: data,
    redirect: 'follow'
  };

  const response = await fetch(`${baseURL}${url}`, requestOptions);
  const result = await response.text();
  return JSON.parse(result);
}

export async function put(url, data, config = {}) {
  addAuthHeader();
  try {
    const response = await axiosApi.put(url, { ...data }, { ...config });
    return response.data;
  } catch (e) {
    return check(e);
  }
}

export async function del(url, config = {}) {
  addAuthHeader();
  try {
    const response = await axiosApi.delete(url, { ...config });
    return response.data;
  } catch (e) {
    return check(e);
  }
}

export async function checkHealth() {
  try {
    const response = await axios.get(`${baseURL}/health`);
    return response.data;
  } catch (error) {
    return error?.response?.data || { status: 'DOWN', error: error.message };
  }
}

